import React from 'react';
import LandingPage from './layout/LandingPage';


function App() {
  return (
    <div className='container-landing-page'>
      <LandingPage />
    </div>
  );
}

export default App;
